export default "__VITE_ASSET__DrSdHbqD__"